import { render, staticRenderFns } from "./FormularioSolicitacao.vue?vue&type=template&id=6ffe894c&"
import script from "./FormularioSolicitacao.vue?vue&type=script&lang=js&"
export * from "./FormularioSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports